/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The status of an authentication event.
*/
export enum AuditLogAuthStatus {
  Success = 'SUCCESS',
  Failure = 'FAILURE'
}
